import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SupplyForecastOverviewComponent } from './supply-forecast-overview.component';

const routes: Routes = [
  {
    path: '',
    component: SupplyForecastOverviewComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupplyForecastOverviewRoutingModule { }
